function formatMoney(amount, withCurrency = true, inCents = true) {
  const currencyCode = window.Shopify.currency.active || "USD";
  const countryCode = window.Shopify.country || "US";
  const languageCode = window.Shopify.locale || "en";
  const locale = `${languageCode}-${countryCode}`;
  const parsedAmount = typeof amount === "string" ? parseInt(amount) / 100 : amount / 100;
  const roundedAmount = parsedAmount.toFixed(inCents ? 2 : 0);
  const formatter = new Intl.NumberFormat(locale, {
    style: withCurrency ? "currency" : "decimal",
    currency: currencyCode,
    currencyDisplay: "narrowSymbol",
    minimumFractionDigits: inCents ? 2 : 0,
    maximumFractionDigits: inCents ? 2 : 0
  });
  return formatter.format(parseFloat(roundedAmount));
}
export {
  formatMoney as f
};
